import { useDisplayVariant } from 'modules/productDetail'
import * as React from 'react'
import styled from 'styled-components'
import useTranslations from 'hooks/useTranslations'
import Button from 'theme/atoms/Button'
import config from 'config'
import * as evt from './events'

type Props = {
  path: string
}

export default function CustomizableButton(props: Props) {
  const t = useTranslations<'templates-PDP'>()
  const variant = useDisplayVariant()
  if (
    !config.features.customizableUrl ||
    variant.data.attributes?.CUSTOMIZEABLE?.values[0].value !== 'Kann'
  )
    return null

  return (
    <Wrapper
      className="CustomizableButton"
      data-cy-handle="customizable-btn"
      data-cy-state="is-customizable"
      variation="secondary"
      to={config.features.customizableUrl as string}
      onClick={() => {
        evt.customizableBtnClick(
          variant.data.title,
          props.path,
          variant.data.sku
        )
      }}
      onKeyDown={(e) => {
        if (e.key === ' ') {
          e.preventDefault()
          evt.customizableBtnClick(
            variant.data.title,
            props.path,
            variant.data.sku
          )
          window.location.href = config.features.customizableUrl as string
        }
      }}
    >
      {t('customizable_btn')}
    </Wrapper>
  )
}

const Wrapper = styled(Button)``
